import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { rests } from '@core/util/rests';
import { environment } from '@env/*';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { Permissions } from '@core/util/permissions.enum';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  public static permissions = new Map<Permissions, Permissions>();

  constructor(private http: HttpClient) {}

  login(credentials: { login: string; password: string }) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json; charset=utf-8',
      Authorization: 'Basic ' + btoa(credentials.login + ':' + credentials.password),
    });
    return this.http.get(rests.auth.login, { headers });
  }

  logout(canNavigate = true) {
    localStorage.clear();
    AuthService.permissions.clear();
    if (canNavigate) {
      window.location.href = `${environment.partnersUrl}/auth/login`;
    }
  }

  isAuthenticated() {
    return !!localStorage.getItem(environment.authToken);
  }

  setTokenInStorage(tokenName, tokenValue) {
    localStorage.setItem(tokenName, tokenValue);
  }

  getTokenFromStorage(tokenName) {
    return localStorage.getItem(tokenName);
  }

  removeToken(tokenName) {
    localStorage.removeItem(tokenName);
  }

  getPermissions(): Observable<Permissions[]> {
    return this.http.get<Permissions[]>(rests.auth.permissions);
  }

  refreshToken() {
    return this.http
      .get<{ session_token: string }>(rests.auth.refresh_token)
      .pipe(tap((res) => this.setTokenInStorage(environment.authToken, res.session_token)));
  }

  setPermission(perms: Map<Permissions, Permissions>) {
    AuthService.permissions = perms;
  }
}
